import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, useParams } from "react-router-dom";

import * as callActions from "../../../actions/callActions";

import HeaderWrapper from "../../common/HeaderWrapper";
import CallNoteList from "./CallNoteList";

const CallNotesPage = ({ call, isMobile, actions }) => {
  const { id } = useParams();

  useEffect(() => {
    if ((!call || !Object.keys(call).length) && id) {
      actions.getCall(id, false);
    }
  }, [call, id, actions]);

  return (
    <>
      <HeaderWrapper breadcrumbs={[{ label: "Notes" }]} isMobile={isMobile} />
      <div className="content-wrapper transparent">
        <CallNoteList call={call} isMobile={isMobile} />
      </div>
    </>
  );
};

CallNotesPage.propTypes = {
  actions: PropTypes.object.isRequired,
  call: PropTypes.object,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    call: state.reducers.call
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...callActions }, dispatch)
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CallNotesPage)
);
